import React from "react";
import { classNames } from "Utils/utils";

/** Same 0–1 score the timesheet table shows as a percent. */
export const readinessPercentOf = (score) => {
  const raw = Number(score);
  if (!Number.isFinite(raw)) return null;
  const clamped = Math.max(0, Math.min(1, raw));
  return Math.round(clamped * 100);
};

const toneOf = (percent) => {
  if (percent >= 90) return "pass";
  if (percent >= 50) return "review";
  return "fail";
};

const CareWatchReadinessCell = ({ score, compact = false }) => {
  const percent = readinessPercentOf(score);

  if (percent === null) {
    return (
      <span className="text-[13px] font-medium text-[#9CA3AF]" aria-label="Readiness unavailable">
        —
      </span>
    );
  }

  const tone = toneOf(percent);

  return (
    <div
      className={classNames(
        "care-watch-readiness",
        compact && "care-watch-readiness--compact"
      )}
    >
      <div
        className="care-watch-readiness-track"
        role="progressbar"
        aria-label="Readiness"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <span
          className={`care-watch-readiness-fill care-watch-readiness-fill--${tone}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span className={`care-watch-readiness-label care-watch-readiness-label--${tone}`}>
        {percent}%
      </span>
    </div>
  );
};

export default CareWatchReadinessCell;
